import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export const UPDATE_STATE = 'UPDATE_STATE';

// Set the page size once here
const PAGE_SIZE = 1000;

// Helper function to append the pageSize to an api
function withPageSize(url) {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}pageSize=${PAGE_SIZE}`;
}

function showNotification(dispatch, type, error) {
  dispatch('notifications/SETNOTIFICATION',
    {
      notificationType: 'danger',
      messages: [{ text: error }],
    },
    { root: true });
}

function fetchLookup({
  dispatch,
  commit,
  state,
  api,
  lookup,
  loadingVariable,
  errorVariable,
}) {
  // already loaded in an error state, return the error
  if (state[errorVariable]) {
    return Promise.reject(state[errorVariable]);
  }

  // already loaded succssfully, return the data
  if (state[lookup].length && !state[loadingVariable]) {
    return Promise.resolve(state[lookup]);
  }

  // initial load of the data
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios.get(encodeURI(`${api}`));
      // TODO update the sources API!
      commit(UPDATE_STATE, { lookup, value: (res.data.data) ? res.data.data : res.data });
      commit(UPDATE_STATE, { lookup: loadingVariable, value: false });
      resolve(state[lookup]);
    } catch (e) {
      showNotification(dispatch, 'danger', e);
      commit(UPDATE_STATE, { lookup: loadingVariable, value: false });
      commit(UPDATE_STATE, { lookup: errorVariable, value: e });
      reject(e);
    }
  });
}

export default {
  actions: {
    loadAttributes({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: withPageSize('attributes'),
        lookup: 'attributes',
        loadingVariable: 'loadingAttributes',
        errorVariable: 'errorAttributes',
      });
    },
    loadCDFValidValues({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: 'cdfs',
        lookup: 'cdfValidValues',
        loadingVariable: 'loadingCDFs',
        errorVariable: 'errorCDFs',
      });
    },
    loadCertificateTypes({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: 'certificate-types',
        lookup: 'certificateTypes',
        loadingVariable: 'loadingCertificateTypes ',
        errorVariable: 'errorCertificateTypes',
      });
    },
    loadDatamartTypes({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: 'datamart-types',
        lookup: 'datamartTypes',
        loadingVariable: 'loadingDatamartTypes',
        errorVariable: 'errorDatamartTypes',
      });
    },
    loadDmSchoolYears({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: 'directmatch/schoolyears',
        lookup: 'dmSchoolYears',
        loadingVariable: 'loadingDmSchoolYears',
        errorVariable: 'errorDmSchoolYears',
      });
    },
    loadDmTransactionStatuses({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: 'directmatch/transactions/statuses',
        lookup: 'dmTransactionStatuses',
        loadingVariable: 'loadingDmTransactionStatuses',
        errorVariable: 'errorDmTransactionStatuses',
      });
    },
    loadEthnicities({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: 'ethnicities',
        lookup: 'ethnicities',
        loadingVariable: 'loadingEthnicities',
        errorVariable: 'errorEthnicities',
      });
    },
    loadEthnicSubGroups({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: 'ethnic-sub-groups',
        lookup: 'ethnicSubGroups',
        loadingVariable: 'loadingEthnicSubGroups',
        errorVariable: 'errorEthnicSubGroups',
      });
    },
    loadFacilities({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: withPageSize('facilities'),
        lookup: 'facilities',
        loadingVariable: 'loadingFacilities',
        errorVariable: 'errorFacilities',
      });
    },
    loadGenders({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: withPageSize('genders?sort=[{"field":"description"}]'),
        lookup: 'genders',
        loadingVariable: 'loadingGender',
        errorVariable: 'errorGenders',
      });
    },
    loadGrades({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: withPageSize('grades'),
        lookup: 'grades',
        loadingVariable: 'loadingGrades',
        errorVariable: 'errorGrades',
      });
    },
    loadHighestDegrees({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: 'highest-degrees',
        lookup: 'highestDegrees',
        loadingVariable: 'loadingHighestDegrees',
        errorVariable: 'errorHighestDegrees',
      });
    },
    loadItinerantFlags({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: 'itinerant-flag',
        lookup: 'itinerantFlags',
        loadingVariable: 'loadingItinerantFlags',
        errorVariable: 'errorItinerantFlags',
      });
    },
    loadJobAssignments({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: 'job-assignments',
        lookup: 'jobAssignments',
        loadingVariable: 'loadingJobAssignments',
        errorVariable: 'errorJobAssignments',
      });
    },
    loadMatchTypes({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: withPageSize('matchtypes?sort=[{"field":"description"}]'),
        lookup: 'matchTypes',
        loadingVariable: 'loadingMatchTypes',
        errorVariable: 'errorMatchTypes',
      });
    },
    loadOrganizations({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: 'organizations',
        lookup: 'organizations',
        loadingVariable: 'loadingOrganizations',
        errorVariable: 'errorOrganizations',
      });
    },
    loadPersonTypes({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: 'person-types',
        lookup: 'personTypes',
        loadingVariable: 'loadingPersonTypes',
        errorVariable: 'errorPersonTypes',
      });
    },
    loadPersonTypeCategories({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: 'person-type-categories',
        lookup: 'personTypeCategories',
        loadingVariable: 'loadingPersonTypeCategories',
        errorVariable: 'errorPersonTypeCategories',
      });
    },
    loadPidAvailableReportTypes({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: '/personid/reports',
        lookup: 'pidAvailableReportTypes',
        loadingVariable: 'loadingPidAvailableReportTypes',
        errorVariable: 'errorPidAvailableReportTypes',
      });
    },
    loadPidExtractStatuses({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: 'personid/extracts/statuses',
        lookup: 'pidExtractStatuses',
        loadingVariable: 'loadingPidExtractStatuses',
        errorVariable: 'errorPidExtractStatuses',
      });
    },
    loadPidSchoolYears({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: 'personid/schoolyears',
        lookup: 'pidSchoolYears',
        loadingVariable: 'loadingPidSchoolYears',
        errorVariable: 'errorPidSchoolYears',
      });
    },
    loadPidTransactionExtractStatuses({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: '/trans-groups?type=app_extract',
        lookup: 'pidTransactionExtractStatuses',
        loadingVariable: 'loadingPidTransactionExtractStatuses',
        errorVariable: 'errorPidTransactionExtractStatuses',
      });
    },
    loadPidTransactionStatuses({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: '/trans-groups?type=profile',
        lookup: 'pidTransactionStatuses',
        loadingVariable: 'loadingPidTransactionStatuses',
        errorVariable: 'errorPidTransactionStatuses',
      });
    },
    loadPrograms({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: withPageSize('programs'),
        lookup: 'programs',
        loadingVariable: 'loadingPrograms',
        errorVariable: 'errorPrograms',
      });
    },
    loadRaces({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: withPageSize('race?sort=[{"field":"description"}]'),
        lookup: 'races',
        loadingVariable: 'loadingRaces',
        errorVariable: 'errorRaces',
      });
    },
    loadResidencyStatuses({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: 'residency-statuses',
        lookup: 'residencyStatuses',
        loadingVariable: 'loadingResidencyStatuses',
        errorVariable: 'errorResidencyStatuses',
      });
    },
    loadRoles({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: withPageSize('roles'),
        lookup: 'roles',
        loadingVariable: 'loadingRoles',
        errorVariable: 'errorRoles',
      });
    },
    loadSources({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: withPageSize('sources'),
        lookup: 'sources',
        loadingVariable: 'loadingSources',
        errorVariable: 'errorSources',
      });
    },
    loadStates({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: withPageSize('states?sort=[{"field":"description"}]'),
        lookup: 'states',
        loadingVariable: 'loadingStates',
        errorVariable: 'errorLoadingStates',
      });
    },
    loadSubmissionTypes({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: 'submission-types',
        lookup: 'submissionTypes',
        loadingVariable: 'loadingSubmissionTypes',
        errorVariable: 'errorSubmissionTypes',
      });
    },
    loadSubjectMatterAreas({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: 'subject-matter-areas',
        lookup: 'subjectMatterAreas',
        loadingVariable: 'loadingSubjectMatterAreas',
        errorVariable: 'errorSubjectMatterAreas',
      });
    },
    loadTitles({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: withPageSize('titles?sort=[{"field":"description"}]'),
        lookup: 'titles',
        loadingVariable: 'loadingTitles',
        errorVariable: 'errorTitles',
      });
    },
    loadUsers({ dispatch, commit, state }) {
      return fetchLookup({
        dispatch,
        commit,
        state,
        api: 'users?sort=[{"field":"lastName","order":"ASC"}]',
        lookup: 'users',
        loadingVariable: 'loadingUsers',
        errorVariable: 'errorUsers',
      });
    },
  },
  getters: {
    activeAttributes: state => state.attributes.filter(a => a.active),
    activeCdfValidValues: state => state.cdfValidValues.filter(s => s.active),
    activeCertificateTypes: state => state.certificateTypes.filter(c => c.active),
    activeDatamartTypes: state => state.datamartTypes.filter(d => d.active),
    activeEthnicSubGroups: state => state.ethnicSubGroups.filter(e => e.active),
    activeEthnicities: state => state.ethnicities.filter(e => e.active),
    activeFacilities: state => state.facilities.filter(f => f.active),
    activeGenders: state => state.genders.filter(g => g.active),
    activeGrades: state => state.grades.filter(g => g.active),
    activeHighestDegrees: state => state.highestDegrees.filter(h => h.active),
    activeItinerantFlags: state => state.itinerantFlags.filter(i => i.active),
    activeJobAssignments: state => state.jobAssignments.filter(j => j.active),
    activeMatchTypes: state => state.matchTypes.filter(m => m.active),
    activeOrganizations: state => state.organizations,
    activePersonTypes: state => state.personTypes.filter(p => p.status === true),
    activePersonTypesForDirectMatch: state => state.personTypes.filter(p => p.category === 'STUDENT' && p.status === true),
    activePrograms: state => state.programs.filter(p => p.active),
    activeRaces: state => state.races.filter(r => r.active),
    activeResidencyStatuses: state => state.residencyStatuses.filter(r => r.active),
    activeRoles: state => state.roles.filter(r => r.active),
    activeSources: state => state.sources.filter(s => s.active),
    activeStates: state => state.states.filter(s => s.active),
    activeSubmissionTypes: state => state.submissionTypes.filter(s => s.active),
    activeSubjectMatterAreas: state => state.subjectMatterAreas.filter(s => s.active),
    activeTitles: state => state.titles.filter(t => t.active),
    aliasIdReportType: (state, getters) => getters.pidAvailableReportTypes.find(r => r.code === 'PID_ALIAS'),
    allPersonTypeCategories: state => state.personTypeCategories,
    allPrograms: state => state.programs,
    allSubmissionTypes: state => state.submissionTypes,
    allRoles: state => state.roles,
    allUsers: state => state.users,
    canceledRecordReportType: (state, getters) => getters.pidAvailableReportTypes.find(r => r.code === 'PID_CANCELED'),
    defaultPersonType: (state, getters) => {
      const active = getters.activePersonTypes;
      if (!Array.isArray(active) || active.length === 0) {
        return null;
      }
      const defaultType = active.find(d => d.defaultType === true);
      return defaultType ? defaultType.code : active[0].code;
    },
    defaultSource: (state, getters) => getters.activeSources.filter(s => s.isDefault === '1'),
    dmSchoolYearsDesc: state => state.dmSchoolYears.sort((a, b) => b - a)
      .map((year, id) => ({ year: year.toString(), id })),
    dmTransactionStatuses: state => state.dmTransactionStatuses,
    indexPrograms: state => state.programs.filter(p => p.programIndex),
    indexProgramsNonDCX: state => state.programs.filter(p => p.programIndex && (!p.code.startsWith('DCX'))),
    nearMatchByLocationReportType: (state, getters) => getters.pidAvailableReportTypes.find(r => r.code === 'PID_NML'),
    noHistoryReportType: (state, getters) => getters.pidAvailableReportTypes.find(r => r.code === 'PID_NO_HIST'),
    pidAvailableReportTypes: state => state.pidAvailableReportTypes,
    pidCanceledTransGroup: state => state.pidTransactionStatuses.find(g => g.group === 'Canceled (Completed)'),
    pidCompletedTransGroup: state => state.pidTransactionStatuses.find(g => g.group === 'ID Assignment Complete (Completed)'),
    pidExtractStatuses: state => state.pidExtractStatuses,
    pidNearMatchesTransGroup: state => state.pidTransactionStatuses.find(g => g.group === 'Ready to Resolve Near Matches/Duplicates'),
    pidSchoolYearsDesc: state => state.pidSchoolYears.sort((a, b) => b - a)
      .map((year, id) => ({ year: year.toString(), id })),
    pidTransactionExtractStatuses: state => state.pidTransactionExtractStatuses,
    pidTransactionStatuses: state => state.pidTransactionStatuses,
    sources: state => state.sources,
    submissionHistoryReportType: (state, getters) => getters.pidAvailableReportTypes.find(r => r.code === 'PID_SUB_HIST'),
  },
  mutations: {
    [UPDATE_STATE](state, { lookup, value }) {
      Vue.set(state, lookup, value);
    },
  },
  namespaced: true,
  state: {
    attributes: [],
    cdfValidValues: [],
    certificateTypes: [],
    datamartTypes: [],
    dmSchoolYears: [],
    dmTransactionStatuses: [],
    ethnicSubGroups: [],
    ethnicities: [],
    facilities: [],
    genders: [],
    grades: [],
    highestDegrees: [],
    itinerantFlags: [],
    jobAssignments: [],
    matchTypes: [],
    organizations: [],
    personTypeCategories: [],
    personTypes: [],
    pidAvailableReportTypes: [],
    pidExtractStatuses: [],
    pidSchoolYears: [],
    pidTransactionExtractStatuses: [],
    pidTransactionStatuses: [],
    programs: [],
    races: [],
    residencyStatuses: [],
    roles: [],
    sources: [],
    states: [],
    submissionTypes: [],
    subjectMatterAreas: [],
    titles: [],
    users: [],

    errorAttributes: null,
    errorCDFs: null,
    errorCertificateTypes: null,
    errorDatamartTypes: null,
    errorDmSchoolYears: null,
    errorDmTransactionStatuses: null,
    errorEthnicSubGroups: null,
    errorEthnicities: null,
    errorFacilities: null,
    errorGenders: null,
    errorHighestDegrees: null,
    errorItinerantFlags: null,
    errorJobAssignments: null,
    errorMatchTypes: null,
    errorOrganizations: null,
    errorPersonTypeCategories: null,
    errorPersonTypes: null,
    errorPidExtractStatuses: null,
    errorPidSchoolYears: null,
    errorPidTransactionExtractStatuses: null,
    errorPidTransactionStatuses: null,
    errorPrograms: null,
    errorResidencyStatuses: null,
    errorRoles: null,
    errorSubmissionTypes: null,
    errorSubjectMatterAreas: null,
    errorTitles: null,
    errorUsers: null,

    loadingAttributes: true,
    loadingCDFs: true,
    loadingCertificateTypes: true,
    loadingDatamartTypes: true,
    loadingDmSchoolYears: null,
    loadingDmTransactionStatuses: true,
    loadingEthnicSubGroups: true,
    loadingEthnicities: true,
    loadingFacilities: true,
    loadingGender: true,
    loadingGrades: true,
    loadingHighestDegrees: true,
    loadingItinerantFlags: true,
    loadingJobAssignments: true,
    loadingMatchTypes: true,
    loadingOrganizations: true,
    loadingPersonTypeCategories: true,
    loadingPersonTypes: true,
    loadingPidExtractStatuses: true,
    loadingPidSchoolYears: null,
    loadingPidTransactionExtractStatuses: true,
    loadingPidTransactionStatuses: true,
    loadingPrograms: true,
    loadingRaces: true,
    loadingResidencyStatuses: true,
    loadingRoles: true,
    loadingSources: true,
    loadingStates: true,
    loadingSubmissionTypes: true,
    loadingSubjectMatterAreas: true,
    loadingTitles: true,
    loadingUsers: true,
  },
};
